// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ApproachSection_band__5MROP {
  background: var(--bg-tertiary);
  border-top: 1px solid var(--border-light);
  border-bottom: 1px solid var(--border-light);
  padding: var(--space-16) 0;
}

.ApproachSection_head__\\+vAbX {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  max-width: 46ch;
}

.ApproachSection_title__N5gk5 {
  font-size: clamp(1.35rem, 1.08rem + 0.95vw, 1.85rem);
  font-weight: 700;
  line-height: 1.18;
  letter-spacing: -0.022em;
  text-wrap: balance;
}

.ApproachSection_lead__90cf8 {
  font-size: 1.0625rem;
  line-height: 1.55;
  color: var(--text-secondary);
}

/* Gallery */
.ApproachSection_gallery__7I9\\+P {
  display: grid;
  grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.2fr) minmax(0, 0.85fr);
  gap: var(--space-5);
  align-items: start;
  padding-bottom: clamp(24px, 4vw, 56px);
}

.ApproachSection_tile__3jH5Q {
  margin: 0;
  border-radius: var(--radius-lg);
  overflow: hidden;
  background: var(--gray-200);
  box-shadow: var(--shadow-md);
}

.ApproachSection_tile__3jH5Q img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ApproachSection_tallLeft__WXdWw {
  aspect-ratio: 3 / 4;
}

.ApproachSection_wideCenter__tR00O {
  aspect-ratio: 4 / 3;
  margin-top: clamp(28px, 5vw, 72px);
}

.ApproachSection_tallRight__JzGrW {
  aspect-ratio: 3 / 4;
  margin-top: clamp(52px, 9vw, 128px);
}

/* Notes */
.ApproachSection_notes__zmhmg {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-6);
}

.ApproachSection_note__e\\+u7U {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding-top: var(--space-4);
  border-top: 1px solid var(--border);
}

.ApproachSection_noteIcon__y7BZt {
  flex: none;
  width: 20px;
  height: 20px;
  margin-top: 2px;
  color: var(--primary);
}

.ApproachSection_noteTitle__yRzDi {
  display: block;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.4;
  color: var(--text-primary);
}

.ApproachSection_noteBody__A9Hjr {
  margin-top: 3px;
  font-size: 0.9375rem;
  line-height: 1.55;
  color: var(--text-secondary);
  max-width: 44ch;
}

/* Mobile */
@media (max-width: 900px) {
  .ApproachSection_band__5MROP {
    padding: var(--space-12) 0;
  }

  .ApproachSection_gallery__7I9\\+P {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--space-4);
    padding-bottom: 0;
  }

  .ApproachSection_wideCenter__tR00O {
    grid-column: 1 / -1;
    order: -1;
    margin-top: 0;
  }

  .ApproachSection_tallRight__JzGrW {
    margin-top: 0;
  }
}

@media (max-width: 560px) {
  .ApproachSection_band__5MROP {
    padding: var(--space-8) 0;
  }

  .ApproachSection_gallery__7I9\\+P {
    gap: var(--space-3);
  }

  .ApproachSection_wideCenter__tR00O {
    aspect-ratio: 16 / 10;
  }

  .ApproachSection_tile__3jH5Q {
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-sm);
  }

  .ApproachSection_lead__90cf8 {
    font-size: 0.9375rem;
  }

  .ApproachSection_notes__zmhmg {
    grid-template-columns: minmax(0, 1fr);
    gap: var(--space-4);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Landing/ApproachSection.module.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,4CAA4C;EAC5C,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oDAAoD;EACpD,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,2EAA2E;EAC3E,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA,UAAU;AACV;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,WAAW;AACX;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gDAAgD;IAChD,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,+BAA+B;IAC/B,4BAA4B;EAC9B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;AACF","sourcesContent":[".band {\n  background: var(--bg-tertiary);\n  border-top: 1px solid var(--border-light);\n  border-bottom: 1px solid var(--border-light);\n  padding: var(--space-16) 0;\n}\n\n.head {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  max-width: 46ch;\n}\n\n.title {\n  font-size: clamp(1.35rem, 1.08rem + 0.95vw, 1.85rem);\n  font-weight: 700;\n  line-height: 1.18;\n  letter-spacing: -0.022em;\n  text-wrap: balance;\n}\n\n.lead {\n  font-size: 1.0625rem;\n  line-height: 1.55;\n  color: var(--text-secondary);\n}\n\n/* Gallery */\n.gallery {\n  display: grid;\n  grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.2fr) minmax(0, 0.85fr);\n  gap: var(--space-5);\n  align-items: start;\n  padding-bottom: clamp(24px, 4vw, 56px);\n}\n\n.tile {\n  margin: 0;\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  background: var(--gray-200);\n  box-shadow: var(--shadow-md);\n}\n\n.tile img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.tallLeft {\n  aspect-ratio: 3 / 4;\n}\n\n.wideCenter {\n  aspect-ratio: 4 / 3;\n  margin-top: clamp(28px, 5vw, 72px);\n}\n\n.tallRight {\n  aspect-ratio: 3 / 4;\n  margin-top: clamp(52px, 9vw, 128px);\n}\n\n/* Notes */\n.notes {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--space-6);\n}\n\n.note {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-3);\n  padding-top: var(--space-4);\n  border-top: 1px solid var(--border);\n}\n\n.noteIcon {\n  flex: none;\n  width: 20px;\n  height: 20px;\n  margin-top: 2px;\n  color: var(--primary);\n}\n\n.noteTitle {\n  display: block;\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.4;\n  color: var(--text-primary);\n}\n\n.noteBody {\n  margin-top: 3px;\n  font-size: 0.9375rem;\n  line-height: 1.55;\n  color: var(--text-secondary);\n  max-width: 44ch;\n}\n\n/* Mobile */\n@media (max-width: 900px) {\n  .band {\n    padding: var(--space-12) 0;\n  }\n\n  .gallery {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: var(--space-4);\n    padding-bottom: 0;\n  }\n\n  .wideCenter {\n    grid-column: 1 / -1;\n    order: -1;\n    margin-top: 0;\n  }\n\n  .tallRight {\n    margin-top: 0;\n  }\n}\n\n@media (max-width: 560px) {\n  .band {\n    padding: var(--space-8) 0;\n  }\n\n  .gallery {\n    gap: var(--space-3);\n  }\n\n  .wideCenter {\n    aspect-ratio: 16 / 10;\n  }\n\n  .tile {\n    border-radius: var(--radius-md);\n    box-shadow: var(--shadow-sm);\n  }\n\n  .lead {\n    font-size: 0.9375rem;\n  }\n\n  .notes {\n    grid-template-columns: minmax(0, 1fr);\n    gap: var(--space-4);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"band": `ApproachSection_band__5MROP`,
	"head": `ApproachSection_head__+vAbX`,
	"title": `ApproachSection_title__N5gk5`,
	"lead": `ApproachSection_lead__90cf8`,
	"gallery": `ApproachSection_gallery__7I9+P`,
	"tile": `ApproachSection_tile__3jH5Q`,
	"tallLeft": `ApproachSection_tallLeft__WXdWw`,
	"wideCenter": `ApproachSection_wideCenter__tR00O`,
	"tallRight": `ApproachSection_tallRight__JzGrW`,
	"notes": `ApproachSection_notes__zmhmg`,
	"note": `ApproachSection_note__e+u7U`,
	"noteIcon": `ApproachSection_noteIcon__y7BZt`,
	"noteTitle": `ApproachSection_noteTitle__yRzDi`,
	"noteBody": `ApproachSection_noteBody__A9Hjr`
};
export default ___CSS_LOADER_EXPORT___;
